/** @format */

// For live ===========>
export const base_url = "https://esign.meon.co.in";
export const events_url = "https://pdf.meon.co.in";

// For UAT ================?
// export const base_url = "https://esignuat.meon.co.in";
// export const events_url = "https://meonuat.meon.co.in";

// For local =================>
// export const base_url = "";
// export const events_url = "http://localhost:3001";
